import React from "react";
import { useTranslation } from "react-i18next";
import { UserSearchIcon } from "lucide-react";

interface StudentListEmptyStateProps {
  isError?: boolean;
  hasActiveFilters?: boolean;
}

export const StudentListEmptyState = ({
  isError = false,
  hasActiveFilters = false,
}: StudentListEmptyStateProps) => {
  const { t } = useTranslation();

  const getMessage = () => {
    if (isError) {
      return t("studentCard.gridView.errorStateTitle");
    }
    if (hasActiveFilters) {
      return t("studentCard.gridView.emptyFilterStateTitle");
    }
    return t("studentCard.gridView.emptyStateTitle");
  };

  return (
    <div className="flex h-[300px] flex-col items-center justify-center">
      <UserSearchIcon className="size-12 text-muted-foreground" />
      <div className="font-primary-light mt-8 w-[30%] text-center text-wrap text-muted-foreground">
        {getMessage()}
      </div>
    </div>
  );
};
